export default "__VITE_ASSET__jChg2vL1__"